const config: types.apiConfig.configType = {
	defaultCacheTime: 300000, //ms
	defaultResponseType: 'json',
	timeout: {
		TEST: 120000,
		STG: 120000,
		PROD: 30000,
		DEV: 120000,
	},
	minDelayBetweenSameRequests: 5000, //ms
	protocol: {
		TEST: 'https://',
		STG: 'https://',
		PROD: 'https://',
		DEV: 'http://',
	},
	sources: {
		microAPI: {
			TEST: 'test-om-api.omantel.om/',
			STG: 'test-om-api.omantel.om/',
			PROD: 'om-api.omantel.om/',
			DEV: 'localhost:3001/',
			forceProtocol: 'https://',
			defaultMethod: 'GET',
		},
		omantelMicroApi: {
			TEST: 'test-om-api.omantel.om/',
			STG: 'test-om-api.omantel.om/',
			DEV: 'localhost:3001/',
			PROD: 'om-api.omantel.om/',
			forceProtocol: 'https://',
			defaultMethod: 'GET',
		},
		omantelApi: {
			TEST: 'testportal.omantel.om/OmantelApiMock/webengine/',
			STG: 'testportal.omantel.om/OmantelApi/webengine/',
			DEV: 'localhost:3001/OmantelApi/webengine/',
			PROD: 'portal.omantel.om/OmantelApi/webengine/',
			forceProtocol: 'https://',
			defaultMethod: 'POST',
		},
		securityServices: {
			TEST: 'test-om-api.omantel.om/',
			STG: 'test-om-api.omantel.om/',
			DEV: 'localhost:3001',
			PROD: 'om-api.omantel.om/',
			forceProtocol: 'https://',
			defaultMethod: 'GET',
		},
		eshopApi: {
			TEST: 'testshop.omantel.om',
			STG: 'testshop.omantel.om',
			DEV: 'localhost:3001',
			PROD: 'store.omantel.om',
			forceProtocol: 'https://',
			defaultMethod: 'GET',
		},
		eshopWCSApi: {
			TEST: 'testbusiness.omantel.om',
			STG: 'testbusiness.omantel.om',
			DEV: 'localhost:3001',
			PROD: 'business.omantel.om',
			forceProtocol: 'https://',
			defaultMethod: 'GET',
		},
		eCommerce: {
			TEST: 'testportal.omantel.om/store/products/10001/',
			STG: 'testportal.omantel.om/store/products/10001/',
			PROD: 'portal.omantel.om/proxy/http/store.omantel.om:3737/search/resources/store/10001/',
			DEV: 'localhost:3001/',
			defaultMethod: 'GET',
		},
		mocky: {
			TEST: 'mocky.io/v2/',
			STG: 'mocky.io/v2/',
			PROD: 'mocky.io/v2/',
			DEV: 'mocky.io/v2/',
			forceProtocol: 'http://',
		},
		omantelPortal: {
			TEST: 'testportal.omantel.om/',
			STG: 'testportal.omantel.om/',
			PROD: 'portal.omantel.om/',
			DEV: 'localhost:3001/',
		},
		wcm: {
			TEST: 'testportal.omantel.om/wcm/',
			STG: 'testportal.omantel.om/wcm/',
			PROD: 'portal.omantel.om/wcm/',
			DEV: 'localhost:3001/wcm.',
			defaultMethod: 'GET',
		},
		oldPortal: {
			TEST:
				'https://testportal.omantel.om/Account/!ut/p/z1/jY_BCoJAEIafxSfYf6bV3ONG7oosaYhkewkPIUJZh-j5WzwqWXMZhv_74B_hRSv82L2HvnsNj7G7hfvsk4tiTnMpyZX1gaFJGuNMzQDEaQbsKAsA2SKtiKGk8CF2yGyuJIe9SXAsShdby4RSLnyj98GH2sbSACn95-PLaPz2_YSsfTADlhUnYKVDfR3F8940LYaq11H0ATWg1KQ!/',
			STG:
				'https://testportal.omantel.om/Account/!ut/p/z1/jY_BCoJAEIafxSfYf6bV3ONG7oosaYhkewkPIUJZh-j5WzwqWXMZhv_74B_hRSv82L2HvnsNj7G7hfvsk4tiTnMpyZX1gaFJGuNMzQDEaQbsKAsA2SKtiKGk8CF2yGyuJIe9SXAsShdby4RSLnyj98GH2sbSACn95-PLaPz2_YSsfTADlhUnYKVDfR3F8940LYaq11H0ATWg1KQ!/',
			PROD:
				'https://www.omantel.om/Account/!ut/p/z1/jY_BCoJAEIafxSfYf6bV3ONG7oosaYhkewkPIUJZh-j5WzwqWXMZhv_74B_hRSv82L2HvnsNj7G7hfvsk4tiTnMpyZX1gaFJGuNMzQDEaQbsKAsA2SKtiKGk8CF2yGyuJIe9SXAsShdby4RSLnyj98GH2sbSACn95-PLaPz2_YSsfTADlhUnYKVDfR3F8940LYaq11H0ATWg1KQ!/',
			DEV: 'localhost:3001/',
		},
		graphQL: {
			TEST: 'https://ebu-api.stg.cxp-omantel.com',
			STG: 'https://ebu-api.stg.cxp-omantel.com',
			PROD: 'https://cep-api-ebu.omantel.om',
			DEV: 'https://release-ebu-feb-1-2-0-api.dev.cxp-omantel.com',
		},
	},
	links: {
		businessLink: 'https://www.omantel.om/business',

		privacyPolicy: '//www.omantel.om/Footer2/Privacy%20Policy',
		customerOrderEnglishEshop: 'https://www.omantel.om/gis/customer_order_english_eshop',
		copyrights: '//www.omantel.om/Footer2/Copyrights',
		standardCustomerAgreement: '//www.omantel.om/Footer2/StandardCustomerAgreement',

		cpn: '//www.omantel.om/business/small-medium-enterprise/mobile/addons/cpn',
		roamingPlans: '//www.omantel.om/business/small-medium-enterprise/mobile/addons/roaming-plans',
		mobileInternet: '//www.omantel.om/business/small-medium-enterprise/mobile/addons/mobile-internet',
		additionalServices: '//www.omantel.om/business/enterprise-government/fixed-voice/fixed-line',
		enterpriseGovernment: '//www.omantel.om/business/enterprise-government/fixed-voice/fixed-line',
		fbbPackages: '//www.omantel.om/business/enterprise-government/internet/fixed-business-broadband',
		prepaidInterMinutes: '//www.omantel.om/business/small-medium-enterprise/mobile/prepaid/mobile-business-prepaid',
		prepaidNationalMinutes: '//www.omantel.om/Personal/mobile/hayyak/Hayyak-Plus/Add-ons/National-Calls',
		prepaidRoaming: '//www.omantel.om/Personal/mobile/Roaming/Jawazak-World',
		prepaidOther: '//www.omantel.om/Personal/promotions#prepaid',

		esimSupportedDevices: '//www.omantel.om/Personal/mobile/eSIM',

		authLetterUrl:
			'//www.omantel.om/wcm/connect/e2d4190f-d1f5-411e-b5ca-901e4bf18ac6/Authorization+letter+for+Omantel+Online+Services-VAS+services.pdf?MOD=AJPERES&CACHEID=e2d4190f-d1f5-411e-b5ca-901e4bf18ac6',
		faceBookLink: 'https://www.facebook.com/omantel.om',
		instagramLink: 'https://www.instagram.com/omantel/?igshid=YmMyMTA2M2Y%3D',
		twitterLink: 'https://x.com/omantel',
		youtubeLink: 'https://www.youtube.com/user/omantelom',
		whatsappLink: 'https://api.whatsapp.com/send?phone=96872700700',
	},
	SUPPORT_PHONE: '1235',
	notification_icons: {
		NEW_SERVICE: 'ElementPlus',
		PAYMENT_SUCCESSFUL: 'CheckRound',
		PAYMENT_STATUS_UPDATE: 'Bank',
		ACCOUNT_CHANGE: 'PenTool',
		SERVICE_DISCONNECTED: 'Receipt',
	},
};

export default config;
